import { connect } from 'react-redux';
import BasicPage from './BasicPage';
import {
	getEquipmentById,
	onSubmit,
	deleteEquipmentById,
	resetMeta,
	resetPage
} from '../../../actions/EquipmentDetailPage/BasicPage';
import { getLocations } from '../../../actions/LocationListPage';

const mapsStateToProps = state => ({
	drawerReducer: state.drawerReducer,
	pageProps: state.equipmentDetailPage.basicPageReducer,
	locationsListPageProps: state.locationListPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getEquipmentById(query) {
		dispatch(getEquipmentById(query));
	},
	getLocations(options){
		dispatch(getLocations(options));
	},
	onSubmit(fields) {
		dispatch(onSubmit(fields));
	},
	deleteEquipmentById() {
		dispatch(deleteEquipmentById());
	},
	resetMeta() {
		dispatch(resetMeta());
	},
	resetPage() {
		dispatch(resetPage());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(BasicPage);

